import { useSessionStore } from "@/modules/auth/store/useSessionStore";
import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../constants/routes";

const AuthLayout = () => {
  const { session } = useSessionStore();

  if (session) return <Navigate to={ROUTES.DASHBOARD.HOME} />;

  return (
    <div>
      <Outlet />
    </div>
  );
};
export default AuthLayout;
